import {
	RangeControl,
	Button,
	Dashicon
} from '@wordpress/components';
import ResBtn from '../res-btn';

import './style.scss';

const ResRangleControl = ({
	label,
	controlName,
	objAttrs,
	noUnits,
	units,
	min,
	max,
}) => {
	const { attributes, setAttributes } = objAttrs;
	// const { resMode } = attributes;

	const {
		[`${controlName}DeskRange`]: deskRange,
		[`${controlName}TabRange`]: tabRange,
		[`${controlName}MobRange`]: mobRange,
		[`${controlName}Unit`]: unit,
	} = attributes;

	if (!units) units = units || ['px', 'em', 'rem'];

	const handleReset = (mode) => {
		const fallbackValue = '';
		if (mode === 'Desktop') {
			setAttributes({ [`${controlName}DeskRange`]: fallbackValue });
		} else if (mode === 'Tablet') {
			setAttributes({ [`${controlName}TabRange`]: fallbackValue });
		} else if (mode === 'Mobile') {
			setAttributes({ [`${controlName}MobRange`]: fallbackValue });
		}
	};

	const handleRangeChange = (mode, value) => {
		if (mode === 'Desktop') {
			setAttributes({ [`${controlName}DeskRange`]: value });
		} else if (mode === 'Tablet') {
			setAttributes({ [`${controlName}TabRange`]: value });
		} else if (mode === 'Mobile') {
			setAttributes({ [`${controlName}MobRange`]: value });
		}
	};

	const shouldShowResetIcon = (mode) => {
		if (mode === 'Desktop') {
			return deskRange !== undefined && deskRange !== '';
		} else if (mode === 'Tablet') {
			return tabRange !== undefined && tabRange !== '';
		} else if (mode === 'Mobile') {
			return mobRange !== undefined && mobRange !== '';
		}
		return false;
	};

	return (
		<div className="gutnm-res-rangle-control">
			<p className='gutnm-label'>{label}</p>
			<div className="gutnm-resicon-unit-wrap">
				
				{!noUnits && (
					<div className="units-wrapper">
						{units &&
							units.map((u, index) => (
								<Button
									className="unit-btn"
									variant={
										unit === u
											? 'primary'
											: 'secondary'
									}
									key={index}
									onClick={() =>
										setAttributes({
											[`${controlName}Unit`]: u,
										})
									}
								>
									{u}
								</Button>
							))}
					</div>
				)}
			</div>
			<div className="gutnm-res-controls">
				
					<div className="gutnm-single-rangle">
						<RangeControl
							value={deskRange}
							onChange={(value) =>
								handleRangeChange('Desktop', value)
							}
							min={min}
							max={max}
							allowReset={false}
							trackColor="#00ced1"
						/>
						{shouldShowResetIcon('Desktop') && (
							<button className="reset-icon" onClick={() => handleReset('Desktop')}>
								<Dashicon icon="image-rotate" />
							</button>
						)}
					</div>
			</div>
		</div>
	);
};

export default ResRangleControl;
